__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@of-monorepo/source";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@shared/components", "0.0.1", () => (() => (__webpack_require__("./packages/@shared/components/src/index.ts"))), 1);
			register("@shared/hooks", "0.0.1", () => (() => (__webpack_require__("./packages/@shared/hooks/src/index.ts"))), 1);
			register("@ui/ford-ui-components", "0.9.4", () => (() => (__webpack_require__("./node_modules/@ui/ford-ui-components/index.js"))), 1);
			register("i18next", "25.8.13", () => (() => (__webpack_require__("./node_modules/i18next/dist/esm/i18next.js"))), 1);
			register("react-dom", "19.2.4", () => (() => (__webpack_require__("./node_modules/react-dom/index.js"))), 1);
			register("react-i18next", "16.5.4", () => (() => (__webpack_require__("./node_modules/react-i18next/dist/es/index.js"))), 1);
			register("react-router-dom", "6.29.0", () => (() => (__webpack_require__("./node_modules/react-router-dom/dist/index.js"))), 1);
			register("react", "19.2.4", () => (() => (__webpack_require__("./node_modules/react/index.js"))), 1);
			register("zustand", "5.0.11", () => (() => (__webpack_require__("./node_modules/zustand/esm/index.mjs"))), 1);
			initExternal("webpack/container/reference/of_platform");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};